import { Button } from "antd";
import { dolarMask } from '../../library/helpers/moneyMask.js';

export default function CreditOption({ value, isCheck, onClick }) {
  return (
    <Button
      className={`border-0 !text-xl text-white items-center text-center shadow-none ${isCheck ? 'bg-primary' : 'bg-gray-200'}`}
      size="large"
      onClick={() => onClick(value)}
      htmlType="submit"
      shape="round"
      type="primary"
    >
      {dolarMask(value)}
    </Button>
  )
}